import {
  CustomGetProjectMapsQuery,
  CustomGetProjectMapsQueryVariables,
  useCustomGetProjectMapsQuery,
} from "generated/graphql";
import { useCallback, useMemo } from "react";

export default function useGetProjectMaps(variables: CustomGetProjectMapsQueryVariables) {
  const {
    data: graphqlData,
    loading,
    error,
    fetchMore,
    refetch,
  } = useCustomGetProjectMapsQuery({
    variables,
    fetchPolicy: "no-cache",
  });

  const getData = useCallback(({ data }: { data?: CustomGetProjectMapsQuery }) => {
    return data?.getProjectMaps?.data || null;
  }, []);

  const getPaginatorInfo = useCallback(({ data }: { data?: CustomGetProjectMapsQuery }) => {
    return data?.getProjectMaps?.paginatorInfo || null;
  }, []);

  const data = useMemo(() => {
    return getData({ data: graphqlData });
  }, [graphqlData, getData]);

  const paginatorInfo = useMemo(() => {
    return getPaginatorInfo({ data: graphqlData });
  }, [graphqlData, getPaginatorInfo]);

  return {
    data,
    loading,
    error,
    paginatorInfo,
    fetchMore,
    getData,
    getPaginatorInfo,
    refetch,
  } as const;
}
